import { Checkbox, InputModal } from "@certn/cascadia-react";
import { CheckboxGroup } from "@certn/cascadia-react/components/inputs/checkbox/checkbox-group/CheckboxGroup";
import { slugifyPath } from "@certn/utils";
import { useContext } from "react";

import { CascadiaJsonFormContext } from "../CascadiaJsonFormContext";
import { SummaryItem } from "../components/SummaryItem";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "../wrappers/withCascadiaControlProps";

export function CheckboxGroupControl(props: CascadiaControlProps) {
  const { options, description, path } = props;
  const items: { value: string; label: string; description?: string }[] =
    options.items || [];
  const required = props.required || options.is_required || false;
  const labelInfo =
    options?.info ??
    (options?.more_info ? <InputModal {...options.more_info} /> : undefined);

  const { isSummaryForPath, formID } = useContext(CascadiaJsonFormContext);

  if (isSummaryForPath?.(path)) {
    const selectedOption = items.find((item) => item.value === props.data);

    return (
      <SummaryItem label={props.label}>
        {selectedOption?.value || props.data}
      </SummaryItem>
    );
  }

  return (
    <CheckboxGroup
      description={description}
      errors={props.errors}
      info={labelInfo}
      isDisabled={!props.enabled}
      isInvalid={props.invalid}
      isRequired={required}
      label={props.label}
      name={props.path}
      orientation={options?.orientation}
      onChange={props.setValue}
      value={props.data}
      children={items.map((item, index) => (
        <Checkbox
          key={index}
          value={item.value}
          isCard={options?.card}
          description={item.description}
          onBlur={props.setTouched}
          testID={
            formID
              ? `${formID}-${slugifyPath(props.path)}-checkbox`
              : `${slugifyPath(props.path)}-checkbox`
          }
        >
          {item.label}
        </Checkbox>
      ))}
      testID={
        formID
          ? `${formID}-${slugifyPath(props.path)}-checkbox-group`
          : `${slugifyPath(props.path)}-checkbox-group`
      }
    />
  );
}

CheckboxGroupControl.displayName = "CheckboxGroupControl";

export const CheckboxGroupRenderer =
  withCascadiaControlProps(CheckboxGroupControl);
